import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from "ag-grid-community";
import {AgRendererComponent} from "ag-grid-angular";
import { IntegrationRef } from '../app.model';
import { IntegrationSource } from '../services/integration-table/integration-table.service';

@Component({
  selector: 'app-last-sync-status-render',
  templateUrl: './last-sync-status-render.component.html',
  styleUrls: ['./last-sync-status-render.component.scss']
})
export class LastSyncStatusRenderComponent implements AgRendererComponent {

  public params: ICellRendererParams;
  isDestinationSet: boolean;

  agInit(params: ICellRendererParams): void {
      this.params = params;
      this.isDestinationSet = this.params.data['destinationName'] != null;
  }

  public invokeParentMethod() {
      this.params.context.componentParent.methodFromParent(`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`)
  }

  refresh(): boolean {
      return false;
  }

  routeToDetails() {
    if (this.isDestinationSet) {
      let integration: IntegrationRef = {
        "integrationName": this.params.data.integrationName,
        "sourceId": this.params.data.sourceId,
        "status": this.params.data.status,
        "destinationName": this.params.data.destinationName
      }
      this.params.context.componentParent?.routeToDetails?.(integration);
    }
  }

  getTables(data: IntegrationSource) {
    if (this.params?.context?.componentParent?.getTables) {
      this.params.context.componentParent.getTables(data);
    }
  }

}
